import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { ReviewPage } from './ReviewPage';
export interface ReviewPageRoutingProps extends RouteComponentProps {}

export const ReviewPageRouting = (props: ReviewPageRoutingProps) => {
  return (
    <Switch>
      <Route path={`${props.match.path}/:hotelUuid`} component={ReviewPage} exact />
    </Switch>
  );
};
